import { useCallback, useState } from 'react';

import { Map } from 'features/map/Map';
import { withSegmentTooltip } from 'features/map/hooks/withSegmentTooltip';
import { ComparisonPicker } from 'features/task_bar/ComparisonPicker';
import { NRTDatePicker } from 'features/task_bar/DatePicker';
import { TaskBar } from 'features/task_bar/TaskBar';
import { WorkflowNrtSkeleton } from 'features/workflow_nrt/WorkflowRecent';

import { ReliesOn } from '../workflow_common/NoDataLoadedWarning';
import {
  WorkflowInfo,
  maybeCarryOverDates,
  maybeCarryOverRouteSelection,
} from '../workflow_common/workflowLookup';
import { QueuingChartWithRegion } from './QueuingChartWithRegion';
import { QueuingMapLegend } from './QueuingMapLegend';

import map_styles from '../map/Map.module.css';

export const workflowQueuing: WorkflowInfo = {
  dataAvailableReliesOn: [ReliesOn.nrtDay, ReliesOn.typicalMonth],
  switchToState: (fromWorkflow, state) => {
    // console.log('Handling switch from ', fromWorkflow, 'to', state.current, state);
    maybeCarryOverDates(state, fromWorkflow);
    maybeCarryOverRouteSelection(state, fromWorkflow);
  },
};

const MapWithTooltip = withSegmentTooltip(Map);

export function WorkflowQueuing() {
  const [tooltipContent, setTooltipContent] = useState(undefined);
  const [enableHover, setEnableHover] = useState<boolean>(true);
  const [selectedTs, setSelectedTs] = useState<string | null>(null);
  const [selectedMin, setSelectedMin] = useState<number | null>(null);
  const [isSelectionSticky, setIsSelectionSticky] = useState(false);

  const handleEnableHover = useCallback((next: boolean) => {
    setEnableHover((prev) => (prev === next ? prev : next));
  }, []);

  return (
    <WorkflowNrtSkeleton
      vizRegionComponent={
        <QueuingChartWithRegion
          handleEnableHover={handleEnableHover}
          setMapTooltipContent={setTooltipContent}
          selectedTs={selectedTs}
          setSelectedTs={setSelectedTs}
          selectedMin={selectedMin}
          setSelectedMin={setSelectedMin}
          isSelectionSticky={isSelectionSticky}
          setSelectionSticky={setIsSelectionSticky}
        />
      }
      mapComponent={
        <MapWithTooltip
          enableHover={enableHover}
          enableRouteSelection
          extras={
            <>
              <QueuingMapLegend />
              {tooltipContent && (
                <div
                  className={map_styles.map_tooltip_container_tight}
                  data-hide-in-export
                >
                  {tooltipContent}
                </div>
              )}
            </>
          }
        />
      }
      taskBarComponent={
        <TaskBar segmentInfo="route" savedRoutes="regular">
          <div>
            <NRTDatePicker />
            <ComparisonPicker forceMonthOnly />
          </div>
        </TaskBar>
      }
    />
  );
}
